import React, { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Dropdown, Loader } from "rsuite";
import toast from "react-hot-toast";
/* views & component */
import DatePicker from "../tripDetailComponents/DatePicker";
import SelectPicker from "../tripDetailComponents/SelectPicker";
import DisplayPrice from "../../../../components/DisplayPrice";
/* context */
import { TripContext } from "../../../../context";
import { bookNowValidation } from "../../../../validations";
/* api */
import apiRoutes from "../../../../api/apiRoutes";
import ApiCall from "../../../../api/network";
/* common */
import { tripDetailListIDs } from "../../../../common/data";
import { AI, BS } from "../../../../common/Icons";
import moment from "moment";
import { useSingleTrip } from "../../../../hooks/useQuery/useTrips";

export const ShowPrice = ({ priceInfo, className, symbol = "C$" }) => {
  const { id } = useParams();
  const { isLoading, isError, error, data: TripData } = useSingleTrip(id);
   const data = TripData?.data
  return (<div className={className}>
    {priceInfo?.discounting_member_price && (
      <span className="text-danger strike-through">
        {symbol} {priceInfo?.price}
      </span>
    )}
    <span className={priceInfo?.discounting_member_price ? "text-success ms-1" : ""}>
      <DisplayPrice
        symbol={symbol}
        price={
          priceInfo?.discounting_member_price
            ? priceInfo?.discounting_member_price
            : priceInfo?.price
        }
      />
    </span>
    
    <span>{data?.supplier?.slug == 'just-you' ? "/SGL per person " : "/DBL per person "}</span>
  </div>
  );
}

let initialValue = {
  checkIn: null,
  checkOut: null,
  arrivalCity: null,
  departureCity: null,
  guest: 2
};
// todo
export const showToast = (e) => {
  toast.remove();
  toast.dismiss();
  toast.custom(
    <div className="info-toast">
      <BS.BsInfoCircle size={60} />
      <span className="ms-1">
        Select Date from dates section, If you are unable to book the trip,
        {/* Request a Quote */}
      </span>
    </div>,
    { duration: 1500 }
  );
  e && e.preventDefault();
  const elementToView = document.getElementById(tripDetailListIDs.date_price);
  setTimeout(() => {
    elementToView.scrollIntoView({
      offsetTop: -300,
      behavior: "smooth",
      block: "center",
      inline: "end",
    });
  }, 500);
};
// handleDate
export const getDate = (date) => {
  let modifiedDate;
  if (date !== undefined && date !== null) {
    modifiedDate = new Date(new Date(date).toISOString().slice(0, -1));
    return modifiedDate;
  }
};
const BookingForm = ({ data, handleClose, setRequestAQuote, isSupplierMode }) => {
  // console.log(data, "daddta");
  let isGroup = data?.travel_style?.some((data) => data?.is_group === 1);
  const { bookingData, setBookingData } = useContext(TripContext);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [formValue, setFormValues] = useState({
    checkIn: null,
    checkOut: null,
    arrivalCity: null,
    departureCity: null,
    guest: data?.supplier?.slug === 'just-you' ? 1 : 2, // Adjusted here
  });
  const { checkIn, checkOut, guest, arrivalCity, departureCity } = formValue;
  // handle guest decrement
  const removeGuest = () => {
    if (guest === 1) return;
    setFormValues({
      ...formValue,
      guest: guest - 1,
    });
  };
  // handle quest increments

  const addGuests = () => {
    /* if (data?.passenger_limit) { */
    setFormValues({
      ...formValue,
      // eslint-disable-next-line
      guest: guest + 1,
    });

    /* } */
  };
  // handle change
  const onChange = (name, value) => {
    setFormValues({ ...formValue, [name]: value });
    if (Object.keys(errors).length > 0) {
      if (errors.hasOwnProperty(name)) delete errors[name];
    }
  };

  useEffect(() => {
    setFormValues({ initialValue });
    if (bookingData !== undefined && bookingData !== null) {
      setFormValues({
        guest: bookingData?.guest ? bookingData?.guest : formValue?.guest,
        arrivalCity: bookingData?.arrival,
        departureCity: bookingData?.departure,
        checkIn: getDate(bookingData?.start_date),
        checkOut: getDate(bookingData?.end_date),
      });
      setErrors({});
    } else {
      // Incorporate conditional logic for setting guest count based on supplier's slug
      setFormValues({
        ...formValue,
        guest: data?.supplier?.slug === 'just-you' ? 1 : 2,
      });
    }
    // eslint-disable-next-line
  }, [bookingData]);

  // handle submit
  const onSubmit = async () => {
    let validations = bookNowValidation(formValue);
    if (Object.keys(validations).length > 0) {
      setErrors(validations);
      return;
    }
    // setLoading(true);

    // open model
    setRequestAQuote(true);
    // const formData = new FormData();
    // formData.append("tour_id", data?.id);
    // formData.append("tour_departure_date_id", bookingData?.id);
    // formData.append("arrival_city_id", arrivalCity);
    // formData.append("departure_city_id", departureCity);
    // formData.append("number_of_passengers", guest);
    // const response = await ApiCall.any(apiRoutes.bookNow, {}, formData);
    // if (response?.status === 1) {
    //   handleClose && handleClose();
    //   setBookingData({});
    //   setFormValues({ guest: 1 });
    //   toast.success(
    //     "Trip Booked Successfully, You will get a confirmation email shortly",
    //     { duration: 2500 }
    //   );
    // }
    // setLoading(false);
  };

    const lowestPriceDate = data?.departure_dates.reduce((lowest, current) => {
        return current.price < lowest.price ? current : lowest;
    }, data?.departure_dates[0]);

  return (
    <>
      <div id="booknow" className="form--modal text-unselectable p-0">
        {/* {isGroup ? null : (
         */}{" "}
        <div className="d-flex justify-content-between flex-column flex-md-row flex-lg-row ">
          <h6 className="white-space-wrap">
            {bookingData?.price ? (
              <ShowPrice
                symbol={data?.currency}
                priceInfo={bookingData}
                className={"primary--color"}
              />
            ) : (
              data?.departure_dates?.length > 0 && (
                <ShowPrice
                  symbol={data?.currency}
                  priceInfo={lowestPriceDate}
                />
              )
            )}
          </h6>

          {data?.reviews?.length > 0 ? (
            <ul className="d-flex justify-content-between">
              <li className="white-space-wrap">
                <AI.AiOutlineStar className="list-icon" />
                <span>5.0</span>
              </li>
              &nbsp;
              <li className="white-space-wrap ">reviews</li>
            </ul>
          ) : null}
        </div>
        <style>
          {`
                  .rs-dropdown-toggle, .rs-dropdown-toggle.rs-btn {
      width: 100% !important;
    }
  `}
        </style>
        {data?.departure_dates?.length > 0 && (
          <Dropdown
              className='date-and-rates-dropdown'
            menuStyle={{
              overflowY: "scroll",
              width: "100%",
              maxHeight: 200,
              textAlign: "center",
            }}
            style={{ padding: "0.5rem 0", width: "100%" }}
            trigger={["click"]}
            title="View Dates & Rates"
          >
            {data?.departure_dates?.map((ele) => (
              <Dropdown.Item
                disabled={ele?.availability?.toLowerCase() === "not available"}
                onClick={() => {
                  if (ele?.availability?.toLowerCase() !== "not available") {
                    setBookingData({
                      // todo
                      ...ele,
                      guest: formValue?.guest,
                      arrivalName: data?.arrival_cities[0]?.name,
                      departureName: data?.departure_cities[0]?.name,
                      arrival: data?.arrival_cities[0]?.id,
                      departure: data?.departure_cities[0]?.id,
                    });
                  }
                }}
              >
                <>
                  {`${getDate(
                    ele?.start_date
                  ).toLocaleDateString()} ~ ${getDate(
                    ele?.end_date
                  ).toLocaleDateString()} ${data?.currency ? data?.currency : "C$"
                    } ${ele?.discounting_member_price
                      ? ele?.discounting_member_price
                      : ele?.price
                    }${data?.supplier?.slug == 'just-you' ? "/SGL per person " : "/DBL per person "} `}{" "}
                  {/* <div>{`${getDate(
                    ele?.start_date
                  ).toLocaleDateString()} ~ ${getDate(
                    ele?.end_date
                  ).toLocaleDateString()}`}</div>
                  <ShowPrice priceInfo={ele} className={"primary--color"} /> */}
                </>
              </Dropdown.Item>
            ))}
          </Dropdown>
        )}
        {/*  )} */}
        <div className="form-card">
          <div className="card">
            <div className="d-flex justify-content-between">
              <DatePicker
                oneTap
                title={/* isGroup ? "Departure Date" : */ "From"}
                value={checkIn}
                onClick={() => showToast()}
                error={errors?.checkIn}
                onChange={onChange}
                isOnChange={bookingData?.start_date}
              />
              <DatePicker
                oneTap
                title={/* isGroup ? "Arrival Date" : */ "To"}
                value={checkOut}
                onClick={() => showToast()}
                error={errors?.checkOut}
                onChange={onChange}
                isOnChange={bookingData?.end_date}
              />
            </div>
            <div className="d-flex justify-content-between">
              <SelectPicker
                title={"Arrival City"}
                placeholder={"Arrival City"}
                name="arrivalCity"
                error={errors.arrivalCity}
                value={arrivalCity}
                onChange={onChange}
                placement="bottomStart"
                data={data?.arrival_cities}
              />
              <SelectPicker
                title={"Departure City"}
                placeholder={"Departure City"}
                name="departureCity"
                error={errors?.departureCity}
                value={departureCity}
                onChange={onChange}
                placement="bottomEnd"
                data={data?.departure_cities}
              />
            </div>
            <div className="select-container">
              <small>Guest</small>
              <div className="d-flex justify-content-between py-1 px-2">
                <div
                  className="increase-decrease-button minus"
                  onClick={() => removeGuest()}
                >
                  <AI.AiOutlineMinus />
                </div>
                <span className="d-flex justify-content-center align-items-center text-center">
                  Passenger(s) ({guest})
                </span>
                <div
                  className="increase-decrease-button add"
                  onClick={() => addGuests()}
                >
                  <AI.AiOutlinePlus className="icon-color" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="py-1 mt-2">
          {!isSupplierMode && <button
              className="submit-button"
              onClick={() => onSubmit()}
              disabled={loading}
          >
            {loading ? (
                <Loader/>
            ) : !isGroup ? (
                "Request a Quote"
            ) : (
                "Register Now"
            )}
          </button>}
        </div>
        <div className="text-center py-1">
          <p>You won’t be charged yet</p>
        </div>
      </div>
    </>
  );
};

export default BookingForm;
